export default function checkoutForm({ main, on, elm, state, subscribe }) {
	const form = elm.querySelector('#checkout-form');
	const formValidation = elm.querySelector('form-validation');
	const cart = document.querySelector('checkout-cart');
	const intlTel = elm.querySelector('intl-tel');
	let saveTimer = null;
	let lastSavedData = null;
	let country_id = null;
	let shipping = null;
	let payment = null;

	main(_ => {
		setInitialData();

		on('form-validation:submit', 'form', confirm);

		on('change', 'input:not([type="search"]), select, textarea',() => {
			clearTimeout(saveTimer);
			saveTimer = setTimeout(saveFields, 50);
		});

		subscribe('checkout:save', saveFields);
	});

	const setInitialData = function () {
		const {customer, address, shipping_method, payment_method, comment} = state.get();

		const data = {
			'comment': comment
		};

		if (customer) {
			data['customer[firstname]'] = customer.firstname;
			data['customer[lastname]'] = customer.lastname;
			data['customer[email]'] = customer.email;
			data['customer[custom_field][30]'] = customer.custom_field[30];

			intlTel.setNumber(customer.telephone);
		}

		if (address) {
			data['shipping_address[company]'] = address.company;
			data['shipping_address[city]'] = address.city;
			data['shipping_address[address_1]'] = address.address_1;
			data['shipping_address[address_2]'] = address.address_2;
			data['shipping_address[custom_field][29]'] = address.custom_field[29];
			data['shipping_address[postcode]'] = address.postcode;

			country_id = address.country_id;
		}

		if (shipping_method) {
			data['shipping_method'] = shipping_method.code;
			shipping = shipping_method.code;
		}

		if (payment_method) {
			data['payment_method'] = payment_method.code;
			payment = payment_method.code;
		}

		formValidation.setValues(data);
	};

	const confirm = async function (e, { data }) {
		const {language} = state.get();
		const action = `index.php?route=extension/evasota/checkout/confirm&language=${language}`;
		const formData = new FormData();

		Object.entries(data).forEach(([key, value]) => {
			formData.append(key, value);
		});

		try {
			state.set(s => s.loading = true);
			const response = await fetch(action, {
				method: 'POST',
				body: formData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Request failed: ${response.status}`);
			}

			const result = await response.json();

			const waitForConfirm = new Promise(resolve => {
				document.dispatchEvent(new CustomEvent('confirm', {
					detail: { resolve }
				}));
			});

			await waitForConfirm;

			if (result.redirect) {
				location.href = result.redirect;
			}
		} catch (e) {
			console.error(e);
		} finally {
			state.set(s => s.loading = false);
		}
	};

	const saveFields = async function () {
		const {language} = state.get();

		const currentData = getFormData();
		if (currentData === lastSavedData) return;

		lastSavedData = currentData;

		try {
			const formData = new FormData(form);
			const action = `index.php?route=extension/evasota/checkout/checkout.saveFields&language=${language}`;

			const currentCountryId = formData.get('shipping_address[country_id]');
			const currentShipping = formData.get('shipping_method');
			const currentPayment = formData.get('payment_method');

			const response = await fetch(action, {
				method: 'POST',
				body: formData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Request failed: ${response.status}`);
			}

			if (country_id !== currentCountryId || shipping !== currentShipping || payment !== currentPayment) {
				country_id = currentCountryId;
				shipping = currentShipping;
				payment = currentPayment;

				cart.update();
			}
		} catch (e) {
			console.error(e);
		}
	};

	const getFormData = () => {
		return new URLSearchParams(new FormData(form)).toString();
	};
};

export const model = {
	loading: false
};
